<app-logo-area [breadcrumbs]="[{'display': 'Content Platform', commands: ['/o', this.organization()?.id]}]"></app-logo-area>
<main>
  <app-headline-section
    [title]="'Previews'"></app-headline-section>
  <app-airline-select-sections></app-airline-select-sections>
</main>
